import { formatDate, useAuthStore } from '@sentinel/web-core';
import { StateBadge } from '@sentinel/ui';
import { useTranslation } from 'react-i18next';

const K = 'shell.organizationNotice';

/** A steady strip under the topbar while the organization is on trial or suspended: the word
 *  of the state, what it means and until when. Never an alarm, never animated. */
export function OrganizationNotice() {
  const { t } = useTranslation();
  const organization = useAuthStore((s) => s.me?.organization ?? null);
  if (organization === null) return null;
  if (organization.status === 'trial')
    return (
      <div className="orgnotice att" role="status">
        <StateBadge tone="att" label={t(`${K}.trial`)} />
        <span>{t(`${K}.trialText`)}</span>
      </div>
    );
  if (organization.status !== 'suspended') return null;
  return (
    <div className="orgnotice crit" role="status">
      <StateBadge tone="crit" label={t(`${K}.suspended`)} />
      <span>
        {organization.readOnlyUntil === null
          ? t(`${K}.suspendedText`)
          : t(`${K}.suspendedUntil`, { date: formatDate(organization.readOnlyUntil) })}
      </span>
    </div>
  );
}
